// extracted by mini-css-extract-plugin
export default {"root":"TableHead-root-d08410994a34547db706322115044aa8"};